module.exports = __webpack_public_path__ + "static/media/ecover.cf3f2ab7.png";